<template>
  <div>
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver al pasado </v-btn> 
    <h3 v-if="ispreinscribir" class="text-center">Cambiar participante a Inscrito</h3>
    <h3 v-else-if="isgenerarplan" class="text-center">Generar plan de pagos</h3>
    <h3 v-else class="text-center">Formulario de inscripcion:.</h3> 
    <p class="text-center text-primary" style="margin-bottom: 0">
      <small class="center-block">
        <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco
        <span class="text-danger">*</span> son obligatorios
      </small>
    </p> 

    <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
      <p class="text-primary" v-show="!ispreinscribir && !isgenerarplan">
        <b>IV. Datos de Inscripcion:</b>
      </p>
      <div v-show="!ispreinscribir && !isgenerarplan" class="row"
        style="margin-top: 0; margin-bottom: 0; margin-left: 0px; margin-right: 0px; background: #ececec">
        <div class="col-sm-10">
          <BuscarEstudiante ref="abuscarestudiante" :model="newEstudiante" :default="inscripcion"
            :inscripcion="inscripcion" :thiz="btn" />
          <b class="text-danger">
            <small>* Seleccione un estudiante para la inscripcion, (Si no existe use el boton para registrarlo)</small>
          </b>
          <v-spacer></v-spacer>
          <v-btn v-if="btn.show_reg" rounded small outlined color="green" data-toggle="collapse"
            data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <v-icon>mdi-people</v-icon> Crear Nuevo Estudiante</v-btn>
        </div>
      </div>
      <br />

      <registro-estudiante-ck v-if="UNIDAD_NEGOCIO_ID === 3 || UNIDAD_NEGOCIO_ID === 4" :inscripcion="inscripcion"
        v-on:onnewregistro="onnewregistro" />
      <RegistroEstudiante v-else :inscripcion="inscripcion" v-on:onnewregistro="onnewregistro" />

      <p v-if="programa" class="text-center font-weight-bold my-0">
        <span> {{ formatCode(programa) }} </span> <v-spacer></v-spacer> <span>{{ getNomProgram() }}</span>
      </p>

      <div v-if="false" class="row" v-show="!ispreinscribir && !isgenerarplan">
        <div class="col-sm-6">
          <Usuarios :current="true" :model="inscripcion" />
          <small class="text-primary"> <span class="text-danger">*</span> Asesor de la inscripcion. </small>
        </div>
      </div>

      <div class="row" style="background-color: #e8f5fd">
        <div class="col-sm-12">
          <label>
            Observaciones <small>(opcional)</small>
            <textarea v-model.trim="inscripcionrest.observaciones" class="form-control" cols="80" rows="3"
              placeholder="Escriba alguna observacion sobre este participante..."></textarea>
          </label>
        </div>
      </div>

      <div class="row" style="background-color: #fdf3e5">
        <div class="col-sm-12">
          <label>
            Canal de contacto <small>(opcional)</small>
            <v-select :items="canales" dense label="" placeholder="Origen de contacto..."
              v-model="inscripcionrest.canal_id" :disabled="loading_canales" :loading="loading_canales" item-value="id"
              clearable item-text="nombre" />
          </label>
        </div>
      </div>

      <div class="text-center mb-4 mt-4" v-show="!ispreinscribir && !isgenerarplan">
        <label> <input type="checkbox" v-model="preinscripcion" /> Preinscribir </label>
        <small>(Al preinscribir no se define el plan de cuotas del estudiante.)</small>
      </div>

      <div class="row" style="background-color: #cdfac2">
        <div class="col-sm-12" v-show="!preinscripcion">
          <p class="text-primary"><b> Plan de cuotas del estudiante:</b></p>
          <!-- <label> <input type="checkbox" v-model="inscripcionrest.tipo_pago"> En cuotas  </label> <small>(Desmarque para indicar que es al contado)</small> -->
          <div class="form-group row" style="margin-bottom: 0">
            <label for="staticEmail" class="col-sm-3 col-form-label"
              style="margin-bottom: 0; padding-bottom: 0">Seleccione el plan de pagos para el estudiante:</label>
            <div class="col-sm-3" style="margin-bottom: 0">
              <select class="form-control" v-model="plansel" @change="plan_selected">
                <option :key="ind" v-for="(p, ind) in planes" :value="p">{{ p.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="mb-4">
            <small class="text-danger">
              <b>ACLARACION:</b> Si en el caso de no existir el plan de pagos adecuado, contacte con la parte contable para
              registrar el plan necesario. <b>Tomar en cuenta:</b> No puede editar los montos de cada concepto, si puede
              editar la cantidad de cuotas y fechas, pero la suma de todas las cuotas debe ser igual al monto del
              concepto.
            </small>
          </div> 

          <!-- Promociones unificadas (v1 + v3) -->
          <v-alert v-if="planseleccionado.plan_cobro_programa_id && planvalidodescuento" class="pa-3">
            <div class="d-flex align-center mb-2" style="gap:6px;">
              <v-icon small color="orange darken-2">mdi-tag-multiple-outline</v-icon>
              <span class="caption font-weight-bold grey--text text--darken-2">PROMOCIONES DISPONIBLES</span>
              <v-chip v-if="todasLasPromos.length" x-small color="grey darken-1" dark>{{ todasLasPromos.length }}</v-chip>
            </div>

            <v-progress-linear v-if="loadingPromos" indeterminate color="purple" height="2" class="mb-1" />
            <v-combobox
              v-model="promoSeleccionada"
              :items="todasLasPromos"
              item-text="nombre"
              :label="promoSeleccionada ? 'Promoción seleccionada' : 'Seleccione una promoción...'"
              class="white px-3"
              prepend-inner-icon="mdi-basket"
              color="purple"
              hide-details
              clearable
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-chip x-small :color="item._version === 'v3' ? 'blue darken-3' : 'purple'" dark class="ml-2">
                  {{ item._version }}
                </v-chip>
              </template>
              <template v-slot:selection="{ item }">
                <span>{{ item.nombre }}</span>
                <v-chip x-small :color="item._version === 'v3' ? 'blue darken-3' : 'purple'" dark class="ml-2">
                  {{ item._version }}
                </v-chip>
              </template>
            </v-combobox>

            <div v-if="promoSeleccionada" class="mt-3">
              <p class="mb-0 ml-4"><b>Descripción: </b>{{ promoSeleccionada.descripcion }}</p>
              <p class="mb-0 ml-4"><b>Creado por: </b>{{ promoSeleccionada.creado_por }}</p>
              <p class="mb-0 ml-4"><b>Aprobado por: </b>{{ promoSeleccionada.aprobado_por }}</p>

              <!-- Fechas v1 -->
              <template v-if="promoSeleccionada._version === 'v1'">
                <p class="mb-0 ml-4"><b>Fecha inicio: </b>{{ promoSeleccionada.fecha_inicio }}</p>
                <p v-if="$store.state.CARGO.id != 13 && $store.state.CARGO.id != 12" class="mb-0 ml-4">
                  <b>Fecha finalización: </b>{{ promoSeleccionada.fecha_fin }}
                </p>
              </template>

              <!-- Fechas v3 -->
              <template v-if="promoSeleccionada._version === 'v3' && promoSeleccionada.fechas && promoSeleccionada.fechas.length">
                <p class="mb-0 ml-4">
                  <b>Fecha inicio: </b>{{ promoSeleccionada.fechas[0].fecha_inicio }}
                  <b class="ml-2">Fecha fin: </b>{{ promoSeleccionada.fechas[0].fecha_fin }}
                </p>
              </template>

              <v-divider class="my-2" />

              <!-- Descuentos v1 -->
              <template v-if="promoSeleccionada._version === 'v1'">
                <p class="mb-0 ml-6" v-for="(d, ind) in promoSeleccionada.detalle_promocion" :key="ind">
                  <b class="purple--text">{{ d.nombre_concepto }}: </b>
                  {{ d.valor_descuento }} {{ d.is_porcentaje ? '%' : montostr }} de descuento.
                </p>
              </template>

              <!-- Descuentos v3 -->
              <template v-if="promoSeleccionada._version === 'v3'">
                <div v-for="regla in promoSeleccionada.reglas" :key="regla.id">
                  <p v-for="c in regla.conceptos" :key="c.id" class="mb-0 ml-6">
                    <b class="blue--text text--darken-2">Concepto {{ c.nombre_concepto }}: </b>
                    {{ c.valor_descuento }}{{ c.is_porcentaje ? '%' : (' ' + montostr) }} de descuento.
                  </p>
                </div>
              </template>
            </div>

            <span v-if="todasLasPromos.length === 0 && !loadingPromos" class="caption grey--text">
              Sin promociones disponibles para este plan.
            </span>
          </v-alert>

          <div>
            <div class="row mt-2">
              <div class="col-xs-6">
                <p class="my-0 px-2 purple white--text" v-if="is_personal_esam">EL ESTUDIANTE ES PERSONAL DEL GRUPO ESAM</p>
                <p class="my-0" v-if="programa.programa_modulos"> <b>cantidad de modulos:</b> {{ programa.programa_modulos.length }} </p>
                <p class="my-0"> <b>Inicio del programa:</b> {{ programa.fecha_inicio }} </p>
                <p class="my-0"> <b>Primer modulo:</b> inicio {{ getprimermodulo().inicio }} </p>
              </div>
              <div class="col-xs-6" v-if="plansel && plansel.plan_cobro_programa_id">
                <v-select v-model="dia_plazo" :disabled="is_generating_plan" :items="dias_plazo" color="purple" label="Plazo dia de pago:" outlined dense>
                  <template v-slot:item="{item}">
                    <v-list-item ripple @mousedown.prevent > 
                      <v-list-item-content>
                        <v-list-item-title>
                          hasta el <b>{{ item }}</b> de cada mes
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </div>
            </div>

          </div>
          <h6 v-if="isgenerarplan" class="red--text text-center">Recuerde que las fechas de pago no puede ser anterior a
            hoy, cualquier modificacion debe solicitar a la nacional contable</h6>
          <div class="col-8 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div key="ind" vv-for="(p, ind) in planes"> 
              <div vv-show="p.plan_cobro_programa_id == planseleccionado.plan_cobro_programa_id"
                v-for="(r, ind) in planseleccionado.cobros" :key="ind">
                <!-- <template v-if="!r.opcional"> -->
                <div class="row" style="margin-bottom: 4px">
                  <div class="col-sm-3 text-primary">
                    <b> Monto de: {{ r.nombre }} </b> <br />
                    <div v-if="r.monto_original"> 
                      <p class="mb-0 purple--text"><b>Monto original:</b> {{ r.monto_original +' '+ montostr}}</p>
                      <p class="mb-0 purple--text">
                        <b>Monto a descontar:</b> {{ r.valor_descuento }} {{ r.is_porcentaje ? '%' : montostr }}
                      </p>
                    </div>
                    <input @change="cambiocuotas(r)" :disabled="true"
                      title="No puede editar los montos ya asignados, debe cambiar a otro plan"
                      style="display: inline-block" class="xinput input-sm" maxlength="5" type="number"
                      v-model.number="r.monto" placeholder="monto" required="true" />
                  </div>
                  <div class="col-sm-2">
                    <b> Cantidad de Cuotas </b> <small>(max: {{ r.xmaxcuotas }})</small> <br />
                    <input @change="cambiocuotas(r)" class="form-control input-sm" maxlength="5" type="number"
                      :max="r.xmaxcuotas" v-model.number="r.cuotas" placeholder="cuotas" required="true" />
                  </div>
                  <div class="col-sm-3 col-lg-3 pt-10" vv-if="unidad_nego!=1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <label v-bind="attrs" v-on="on">
                          <input type="checkbox" v-model="autoasigfechas" /> Auto cambiar fechas
                        </label>
                      </template>
                      <span>
                        Cada cambio de fecha regenera a las demas, para evitar este efecto desactive esta casilla
                      </span>
                    </v-tooltip>
                  </div>
                </div>

                <div class="row" style="margin-bottom: 4px" v-for="(plan, ind2) in r.pagos" :key="ind2">
                  <div class="col-sm-2 col-sm-offset-3 pt-0 pb-0">
                    <b> # {{ plan.nro_cuota }} </b>
                    <input style="max-width: 110px" class="xinput input-sm" maxlength="5" type="number"
                      v-model.number="plan.monto" placeholder="monto" readonly required="true" />
                  </div>
                  <div class="col-sm-3 pt-5 pb-0"> 
                    <Fecha :model="plan" :xplanes="planseleccionado" :xautogenerarfechas="autoasigfechas"
                      :valueto="'fecha_pago'" :default="plan.xfecha_pago" :datenewrest="true" :xindice="ind"
                      :xisgenerarplan="isgenerarplan" title="Fecha prevista de pago" v-on:fecha_changed="setFechaCustom" />
                  </div>
                </div>
                <!-- </template> -->
              </div>
            </div>
          </div>
          <div class="col-sm-4" v-if="isdevmode" >
            agregar comproblante
            <ComprobantePago @comprobante-guardado="handleComprobanteGuardado"></ComprobantePago> 
          </div>

        </div>
      </div>

      <div class="text-center mb-4" v-show="!preinscripcion">
        <v-divider class="mt-2"></v-divider>
        <small> aqui ira la parte para subir los documentos de inscripcion (carnet, certificado, titulo academico, prov
          nacional,...) </small>
        <div class="row justify-center">
          <div class="col-sm-6">
            <Docus ref="refDocs" v-if="false" />
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <p v-if="programa" class="text-center font-weight-bold my-0">
        <span> {{ formatCode(programa) }} </span> <v-spacer></v-spacer> <span>{{ getNomProgram() }}</span>
      </p>
      <p class="text-center text-danger">{{ msg }}</p>
    </form>

    <div class="text-center"> 
      <div style="display: inline-block" v-show="loading || is_generating_plan" class="loader"></div>
    </div>
    <v-progress-linear class="mx-8" v-if="is_generating_plan" color="green" indeterminate />
    <button v-if="!ispreinscribir && !isgenerarplan" class="center-block btn btn-sm btn-success"
      :disabled="loading || is_generating_plan" @click="validardatosrest()">
      {{ preinscripcion ? 'Preinscribir' : 'Realizar inscripcion' }}
    </button>
    <button v-else-if="isgenerarplan" class="center-block btn btn-sm btn-warning"
      :disabled="loading || is_generating_plan" @click="validarcambioinscrito(0)">
      Generar plan de pagos.
    </button>
    <button v-else class="center-block btn btn-sm btn-success" :disabled="loading || is_generating_plan"
      @click="validarcambioinscrito(1)">
      Realizar cambio a inscrito.
    </button>

    <notifications group="auth" position="bottom right" />
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <modal_propuesta ref="refmodal_propuesta"/>
  </div>
</template>
<script>
  import Usuarios from '@/components/AUsuariosActivos.vue';
  import BuscarEstudiante from '@/components/ABuscarEstudiante.vue';
  import Alertas from '@/components/AAlertas.vue';
  import RegistroEstudiante from '@/components/ARegEstudiante.vue';
  import RegistroEstudianteCk from './ciberkids/RegNewStudent.vue';
  import Fecha from '@/components/AFechax.vue'; 
  import { isNullObject, error } from '@/components/Utils.js';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import { mapState } from 'vuex';
  import Docus from './Inscripcionrest-docs.vue'
  import { cargarDocs } from './documents/docs-up'
  import modal_propuesta from './upi/modal_propuesta.vue';
import ComprobantePago from '@/components/ComprobantePago.vue';
import { validarFechasPagos } from './utils/plan_cobros';


export default {
  data() {
    return {
      comprobanteData: {},
      remote_plan: [],
      api_rest: process.env.VUE_APP_API_REST,
      activo: true,
      btn: {
        show_reg: false,
      },
      //preinscribir: true,
      autoasigfechas: true,
      datosvalidos: true,
      msg: '',
      modelinscrito: {},
      idNewInscripcion: 0,
      programa: {},
      cuotas_validas: { valido: true },
      atras: 'programas',
      loading_promo: false,
      loading_promo_v3: false,
      xpromos_v3: [],
      xpromo_v3: null,
      promoSeleccionada: null,
      preinscripcion: false,
      newEstudiante: {
        iddepartamento: null,
        idciudad: null,
        idprofesion: null,
        iduniversidad: null,
        idempresa: null,
        idgrado: null,
      },
      inscripcion: {
        idestudiante: null,
        tipopago: false,
        idprograma: null,
        idusuario: null,
        matricula: { monto: -1, fecha: '' },
        certificacion: { monto: -1, fecha: '' },
        monto: { monto_colegiatura: -1, cuotas: null, fecha_ins: null },
        observaciones: null,
      },
      matriculaCreada: { id: -1 },
      cuotas_por_pagar: [],
      cuotas: [],

      loading: false,
      loading_canales: false,
      cuotasfalse: 0,
      planseleccionado: { plan_cobro_programa_id: null, cobros: [] },
      plansel: { plan_cobro_programa_id: null },
      inscripcionrest: {
        programa_id: null,
        estudiante_id: null,
        asesor_id: null,
        observaciones: null,
        registrado_por: 1,
        tipo_pago: true, // true  a cuotas, false al contado
        plan_pagos: [],
        canal_id: null,
      },
      plan_depagos: [],
      cobros_programa: [],
      ispreinscribir: false,
      isgenerarplan: false,
      ispreinscrito: { id: null },
      isgenerarplaninscrito: { id: null },

      planes: [],
      xpromos: [],
      xpromo: null,
      planvalidodescuento: false,
      debounceTimer: null,
      is_generating_plan: false,
      tiempoAnterior: 0,
      canales: [],
      isdevmode: false,
      dias_plazo: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
      dia_plazo: 15,
      is_personal_esam: false,
      unidad_nego: 0, 
    };
  },
  components: {
    Usuarios,
    BuscarEstudiante,
    Alertas,
    RegistroEstudiante,
    RegistroEstudianteCk,
    Fecha,
    Docus,
    ComprobantePago,
    modal_propuesta,
  },
  watch: {
    UNIDAD_NEGOCIO_ID() { },
    plansel: function () {
      this.aplicarPromocion();
    },
    xpromo: function () {
      const idprograma_omit = 3056;
      const idprograma_omit2 = 3059;
      if (this.programa && (this.programa.id == idprograma_omit || this.programa.id == idprograma_omit2)) {
        this.$root.$notify.show(`Este programa no esta permitido para aplicarse la promocion.`, {
          color: 'danger',
          x: 'left',
        });
        this.xpromo = null;
        return;
      }
      if (this.xpromo) this.xpromo_v3 = null;
      this.aplicarPromocion();
    },
    xpromo_v3: function () {
      if (!this.xpromo_v3) return;
      this.xpromo = null;
      this.aplicarPromocionV3();
    },
    promoSeleccionada: function (val) {
      if (!val) {
        this.xpromo = null;
        this.xpromo_v3 = null;
        return;
      }
      if (val._version === 'v3') {
        this.xpromo_v3 = val;
        this.xpromo = null;
      } else {
        this.xpromo = val;
        this.xpromo_v3 = null;
      }
    },
    'planseleccionado.cobros': {
      deep: true,
      handler(a) { 
        this.generando_plan_cobros(a) 
      },
    },
    'dia_plazo': function() {
      this.generando_plan_cobros(this.planseleccionado.cobros)
    },
    'inscripcion.idestudiante': function(){
      if(this.inscripcion.idestudiante){
        const est = this.inscripcion.idestudiante;
        this.verificar_personal_esam(est)
      } 
      
    }
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      store_inscripcion: (state) => state.inscripcion.value,
    }),
    montostr(){
      if(this.programa && this.programa.sede) {
        const un = this.programa.sede.unidad_negocio
        if( un == 15 ) return '$'
      }
      return 'Bs.'
    },
    todasLasPromos() {
      const v1 = (this.xpromos || []).map(p => ({ ...p, _version: 'v1' }));
      const v3 = (this.xpromos_v3 || []).map(p => ({ ...p, _version: 'v3' }));
      return [...v1, ...v3];
    },
    loadingPromos() {
      return this.loading_promo || this.loading_promo_v3;
    },
  },
  methods: {
    getprimermodulo(){
      if(!this.programa.programa_modulos) this.programa.programa_modulos = []
      const r = this.programa.programa_modulos.find(m=>m.numero == 1)
      if(r) {
        return r
      }
      return {}
    },
    formatearFecha(date) {
      let y = date.getFullYear();
      let m = String(date.getMonth() + 1).padStart(2, '0');
      let d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    handleComprobanteGuardado(data) {
      window.console.log("Comprobante guardado:", data);
      this.comprobanteData = data;
      if (!data.archivo) {
        window.console.error("Error: No se encontró un archivo en data.archivo");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(data.archivo);
      reader.onload = () => {  // Usamos una arrow function para mantener el contexto de `this`
        this.comprobanteData.archivoComprobante = reader.result.split(",")[1];
        window.console.log("Archivo en Base64:", this.comprobanteData.archivoComprobante);
        window.console.log("Comprobante Data:", this.comprobanteData);
      };
      reader.onerror = (error) => {
        window.console.error("Error al convertir el archivo a Base64:", error);
      }; 
    }, 
    obtenerFechaActual(defecto = null) {
      let fecha = new Date();
      if (defecto) fecha = new Date(defecto + 'T00:00:00-04:00');
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses son de 0 a 11
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }, 
    plan_selected() {
      this.xpromos = [];
      this.xpromo = null;
      this.xpromos_v3 = [];
      this.xpromo_v3 = null;
      this.promoSeleccionada = null;
      if (this.plansel && this.plansel.plan_cobro_programa_id && this.programa) {
        this.getPromo(this.programa.id);
        if (this.programa.universidad_id == 9) {
          this.getPromoV3(this.programa.id, this.plansel.plan_cobro_programa_id);
        }
      }
      setTimeout(() => {
        const hoy = this.formatearFecha(new Date());
        window.console.log('plan_selected', hoy);
        this.generando_plan_cobros_with_custom_fecha(this.planseleccionado.cobros, hoy);
      }, 3000);
    },
    setFechaCustom(fecha){
      this.generando_plan_cobros_with_custom_fecha(this.planseleccionado.cobros,fecha)
    },
    /* generando_plan_cobros(planes_cobro){
      if (!this.autoasigfechas) {
          this.is_generating_plan = false;
          return;
        }

        const tiempoActual = new Date().getTime();
        let cur = tiempoActual - this.tiempoAnterior; 
        if (cur < 1000) {
          return;
        }
        this.tiempoAnterior = tiempoActual;
        this.is_generating_plan = true;
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(() => {
          if (!this.autoasigfechas) {
            this.is_generating_plan = false;
            return;
          }
          
          const hoy = new Date(this.obtenerFechaActual() + 'T00:00:00');
          const diaplazo = this.dia_plazo; 
          let ultima_fecha_colegiatura = new Date(this.obtenerFechaActual() + 'T00:00:00');

          // ordenar módulos
          const modulos = [...this.programa.programa_modulos]
            .sort((a, b) => a.numero - b.numero)
            .map(m => ({
              ...m,
              inicioDate: new Date(m.inicio + 'T00:00:00')
            })).filter(m=>m.numero>0);

          planes_cobro.forEach(concepto => {
            const cuotas = concepto.pagos;
            const totalCuotas = concepto.xmaxcuotas;

            window.console.log('concepto',concepto);
            

            if (totalCuotas === 0) return; 
            let modulosPasados = modulos.filter(m => m.inicioDate < hoy);
            let modulosPendientes = modulos.filter(m => m.inicioDate >= hoy);

            // window.console.log('modulosPasados',modulosPasados);
            // window.console.log('modulosPendientes',modulosPendientes);
            

            let cuotaIndex = 0; 

            // 1. Cuotas atrasadas → hoy
            modulosPasados.forEach(() => {
              if (cuotaIndex < totalCuotas) {
                if(concepto.concepto_id == 3){  
                  const ms = planes_cobro.filter(x=>x.concepto_id == 2)
                  let dx = 0
                  if(ms) {
                    dx = ms[0].pagos.length
                    dx -= 1
                  }

                  window.console.log('>>>>', dx);
                  
                  hoy.setMonth(ultima_fecha_colegiatura.getMonth() + 3 + dx);
                  hoy.setDate(diaplazo);
                }
                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(hoy);
                cuotaIndex++;
              }
            });

            // 2. Cuotas alineadas a módulos
            modulosPendientes.forEach(m => {
              if (cuotaIndex < totalCuotas) {
                const fecha = new Date(
                  m.inicioDate.getFullYear(),
                  m.inicioDate.getMonth(),
                  diaplazo
                ); 

                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(fecha);
                ultima_fecha_colegiatura = fecha
                cuotaIndex++;
              }
            });

            // 3. Si sobran cuotas → seguir mes a mes
            let baseFecha;
            if (modulos.length) {
              const ultimoModulo = modulos[modulos.length - 1].inicioDate;
              baseFecha = new Date(
                ultimoModulo.getFullYear(),
                ultimoModulo.getMonth(),
                diaplazo
              );
            } else {
              baseFecha = new Date(hoy);
            } 
            
            if (!baseFecha || isNaN(baseFecha.getTime())) {
              baseFecha = new Date(hoy);
            }

            while (cuotaIndex < totalCuotas) {
              baseFecha.setMonth(baseFecha.getMonth() + 1); 
              if(cuotas[cuotaIndex]) { 
                /* if(concepto.concepto_id == 3){  
                  const ms = planes_cobro.filter(x=>x.concepto_id == 2)
                  let dx = 0
                  if(ms) dx = ms.length

                  window.console.log('dx',dx);
                  
                  baseFecha.setMonth(5+dx);
                  baseFecha.setDate(diaplazo);
                } 

                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(baseFecha);
              }
              cuotaIndex++;
            }
          });

          this.is_generating_plan = false; 
        }, 1400);
    }, */
    generando_plan_cobros(planes_cobro){
      if (!this.autoasigfechas) {
          this.is_generating_plan = false;
          return;
        }

        const tiempoActual = new Date().getTime();
        let cur = tiempoActual - this.tiempoAnterior; 
        if (cur < 1000) {
          return;
        }
        this.tiempoAnterior = tiempoActual;
        this.is_generating_plan = true;
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(() => {
          if (!this.autoasigfechas) {
            this.is_generating_plan = false;
            return;
          }
          
          const hoy = new Date(this.obtenerFechaActual() + 'T00:00:00');
          const diaplazo = this.dia_plazo; 
          let ultima_fecha_colegiatura = new Date(this.obtenerFechaActual() + 'T00:00:00');

          // ordenar módulos
          const modulos = [...this.programa.programa_modulos]
            .sort((a, b) => a.numero - b.numero)
            .map(m => ({
              ...m,
              inicioDate: new Date(m.inicio + 'T00:00:00')
            })).filter(m=>m.numero>0);

          planes_cobro.forEach(concepto => {
            const cuotas = concepto.pagos;
            const totalCuotas = concepto.xmaxcuotas;

            window.console.log('concepto',concepto);
            

            if (totalCuotas === 0) return; 
            let modulosPasados = modulos.filter(m => m.inicioDate < hoy);
            let modulosPendientes = modulos.filter(m => m.inicioDate >= hoy);

            // window.console.log('modulosPasados',modulosPasados);
            // window.console.log('modulosPendientes',modulosPendientes);
            

            let cuotaIndex = 0; 

            // 1. Cuotas atrasadas → hoy
            modulosPasados.forEach(() => {
              if (cuotaIndex < totalCuotas) {
                if(concepto.concepto_id == 3){  
                  const ms = planes_cobro.filter(x=>x.concepto_id == 2)
                  let dx = 0
                  if(ms) {
                    dx = ms[0].pagos.length
                    dx -= 1
                  }

                  window.console.log('>>>>', dx);
                  
                  hoy.setMonth(ultima_fecha_colegiatura.getMonth() + 3 + dx);
                  hoy.setDate(diaplazo);
                }
                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(hoy);
                cuotaIndex++;
              }
            });

            // 2. Cuotas alineadas a módulos
            modulosPendientes.forEach(m => {
              if (cuotaIndex < totalCuotas) {
                const fecha = new Date(
                  m.inicioDate.getFullYear(),
                  m.inicioDate.getMonth(),
                  diaplazo
                ); 

                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(fecha);
                ultima_fecha_colegiatura = fecha
                cuotaIndex++;
              }
            });

            // 3. Si sobran cuotas → seguir mes a mes
            let baseFecha;
            if (modulos.length) {
              const ultimoModulo = modulos[modulos.length - 1].inicioDate;
              baseFecha = new Date(
                ultimoModulo.getFullYear(),
                ultimoModulo.getMonth(),
                diaplazo
              );
            } else {
              baseFecha = new Date(hoy);
            } 
            
            if (!baseFecha || isNaN(baseFecha.getTime())) {
              baseFecha = new Date(hoy);
            }

            while (cuotaIndex < totalCuotas) {
              baseFecha.setMonth(baseFecha.getMonth() + 1); 
              if(cuotas[cuotaIndex]) { 
                /* if(concepto.concepto_id == 3){  
                  const ms = planes_cobro.filter(x=>x.concepto_id == 2)
                  let dx = 0
                  if(ms) dx = ms.length

                  window.console.log('dx',dx);
                  
                  baseFecha.setMonth(5+dx);
                  baseFecha.setDate(diaplazo);
                }*/ 

                cuotas[cuotaIndex].xfecha_pago = this.formatearFecha(baseFecha);
              }
              cuotaIndex++;
            }
          });

          this.is_generating_plan = false; 
        }, 1400);
    },
    generando_plan_cobros_with_custom_fecha(planes_cobro, fecha_semilla=null){
      if (!this.autoasigfechas) {
          this.is_generating_plan = false;
          return;
        }

        const tiempoActual = new Date().getTime();
        let cur = tiempoActual - this.tiempoAnterior; 
        if (cur < 1000) {
          return;
        }
        this.tiempoAnterior = tiempoActual;
        this.is_generating_plan = true;
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(() => {
          if (!this.autoasigfechas) {
            this.is_generating_plan = false;
            return;
          }
          
          let ultima_fecha_colegiatura = new Date(this.obtenerFechaActual() + 'T00:00:00');
          // const hoy = new Date(this.obtenerFechaActual() + 'T00:00:00');
          const diaplazo = this.dia_plazo;  
          let fechaBase1 = fecha_semilla ? new Date(fecha_semilla + 'T00:00:00') : new Date();
          let fechaBase = fecha_semilla ? new Date(fecha_semilla + 'T00:00:00') : new Date();

          

          window.console.log('planes_cobro', planes_cobro);

          planes_cobro.forEach(concepto => {
            concepto.pagos.forEach((pago,j) => {
              const fecha1 = new Date( fechaBase1.getFullYear(), fechaBase1.getMonth(), fechaBase1.getDate() );
              const fecha = new Date( fechaBase.getFullYear(), fechaBase.getMonth(), diaplazo );
              
              if(j == 0 ) { 
                fechaBase.setMonth(fechaBase1.getMonth())
                pago.xfecha_pago = this.formatearFecha(fecha1)
                if( concepto.concepto_id == 3 ){
                  pago.xfecha_pago = this.formatearFecha(ultima_fecha_colegiatura)
                }
              }
              else {
                pago.xfecha_pago = this.formatearFecha(fecha) 
              }

              fechaBase.setMonth(fechaBase.getMonth() + 1)
              if( concepto.concepto_id == 2){
                ultima_fecha_colegiatura = fecha
                ultima_fecha_colegiatura.setMonth(ultima_fecha_colegiatura.getMonth()+3)
              }
            })
          });

          window.console.log('ultima_fecha_colegiatura',ultima_fecha_colegiatura)

          this.is_generating_plan = false; 

        }, 100);
    },
    
    /*setCustomPlan_autogestionado() {
      if (!this.planseleccionado || !this.planseleccionado.nombre) return;
      const nombrePlan = this.planseleccionado.nombre.trim().toLowerCase();
      if (nombrePlan !== 'plan credito autogestionado') return;

      const cobros = this.planseleccionado.cobros || [];
      cobros.forEach((cobro) => {
        if (!cobro.pagos || cobro.pagos.length !== 4) return;

        const montoTotal = Number(cobro.monto);
        if (!montoTotal) return;

        const primeraCuota = Math.round(montoTotal * 2 / 7);
        const montoRestante = montoTotal - primeraCuota;
        const cuotasRestantes = Math.round(montoRestante / 3);

        cobro.pagos.forEach((pago, index) => {
          if (index === 0) pago.monto = primeraCuota;
          else if (index === 3) pago.monto = montoTotal - primeraCuota - (cuotasRestantes * 2);
          else pago.monto = cuotasRestantes;
          pago.saldo = pago.monto;
        });
      });
    },*/

    aplicarPromocion() {
      let obj = JSON.stringify(this.plansel);
      let plan = JSON.parse(obj);
      if (!plan || !plan.nombre) return;

      this.planvalidodescuento = true; 
      let idsede = this.$store.state.CARGO.idsede;
      if (this.xpromo && plan.cobros /*&& !planvalidodes*/) {
        let vue = this;
        this.xpromo.detalle_promocion.forEach((x) => {
          let cobro = plan.cobros.find((c) => c.concepto_id == x.concepto_pago_id);
          if (cobro) {
            let monto_a_descontar = 0;
            if (x.is_porcentaje) {
              monto_a_descontar = (parseFloat(x.valor_descuento) * cobro.monto) / 100;
              // monto_a_descontar += 0.5;
              if (idsede != 17) {
                // distinto al CAS
                let decimales = monto_a_descontar - (parseInt(monto_a_descontar) / 2) * 2;
                monto_a_descontar = parseInt(monto_a_descontar);
                if (decimales >= 0.6) monto_a_descontar += 1;

                window.console.log('decimales:', decimales, (parseFloat(x.valor_descuento) * cobro.monto) / 100);
                window.console.log('monto_a_descontar', monto_a_descontar);
              }
            } else monto_a_descontar = parseInt(x.valor_descuento);
            cobro.monto_original = cobro.monto;
            cobro.monto = cobro.monto - monto_a_descontar;
            cobro.valor_descuento = x.valor_descuento;
            cobro.is_porcentaje = x.is_porcentaje;
            vue.cambiocuotas(cobro);
          }
        });
        // window.console.log('planseleccionado', plan);
      }
      if (plan.cobros) {
        plan.cobros.forEach((co) => {
          co.xmaxcuotas = co.cuotas;
        });
      }

      let o = JSON.stringify(plan);
      this.planseleccionado = JSON.parse(o);
      let vue = this;
      setTimeout(() => {
        vue.planseleccionado.cobros.forEach((x) => {
          vue.cambiocuotas(x);
        });
        setTimeout(() => {
          vue.setCustomPlan_autogestionado();
        }, 360);
      }, 300); 
    }, 
    setCustomPlan_autogestionado() {
      if (!this.planseleccionado || !this.planseleccionado.nombre) return;
      const nombrePlan = this.planseleccionado.nombre.trim().toLowerCase();
      if (nombrePlan !== 'plan credito autogestionado') return;

      const cobros = this.planseleccionado.cobros || [];
      cobros.forEach((cobro) => {
        if (!cobro.pagos || cobro.pagos.length !== 4) return;

        const montoTotal = Number(cobro.monto);
        if (!montoTotal) return;

        const primeraCuota = Math.round(montoTotal * 2 / 7);
        const montoRestante = montoTotal - primeraCuota;
        const cuotasRestantes = Math.round(montoRestante / 3);

        cobro.pagos.forEach((pago, index) => {
          if (index === 0) pago.monto = primeraCuota;
          else if (index === 3) pago.monto = montoTotal - primeraCuota - (cuotasRestantes * 2);
          else pago.monto = cuotasRestantes;
          pago.saldo = pago.monto;
        });
      });
    },
    getNomProgram() {
      if (this.programa == null) return '?';
      return this.programa.nombre_compuesto;
    },
    verificar_cuotas_personal_esam(){
      const mods = this.programa.programa_modulos
      const colegiaturas = this.planseleccionado.cobros.find(p=>p.concepto_id == 2);
      const cant_cuotas = colegiaturas? colegiaturas.length : 0;
      const cant_modulos = mods? mods.length : 0
      window.console.log('colegiaturas::',cant_cuotas,cant_modulos, this.is_personal_esam);

      if(!this.is_personal_esam && cant_cuotas > cant_modulos){
        return {
          valido: false,
          msg: 'error: hay mas cuotas que modulos, no es posible continuar'
        }
      }
      return {
        valido: true,
        msg: ''
      }
    },
    async verificar_personal_esam(persona){
      this.is_personal_esam = false
      const url = process.env.VUE_APP_RRHH+'/empleados/validar?nro_ci='+persona.num_doc
      const tokenStatic = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaXN0ZW1hIjoic2lzdGVtYV9wb3J0YWwiLCJpYXQiOjE3Mjg1MDgxNTAsImV4cCI6MzE3MjcyOTUwNTUwfQ.mo9Y8O-B4-AIoMt2rHKqVUZrDy_Z5oBZAn1VrrMLFzg';
      const h = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${tokenStatic}`,
            'Content-Type': 'application/json'
        }
      }
      this.existe_in_talento = false;
      this.buscando = true;
      const res = await fetch(url,h).then((response) => response.json()).then((result) =>  (result)).catch((error) =>  (error));
      // window.console.log('res esammm::',res);
      if(res && res.vigente){
        this.is_personal_esam = true 
      }
    },
    validar_modulos_con_fechas(){
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      if(unidad != 1) return; // solo esam

      const mods = this.programa.programa_modulos.filter(m=>!m.inicio || !m.fin)
      // window.console.log('>>modulos::::', mods);
      if(mods && mods.length > 0 ){
        this.$root.$notify.show(`Hay modulos sin fechas de inicio, las inscripciones no estan disponibles`, {color:'red',x: 'right',});
        this.$router.back();
      }
    },
    validar_modulocero(){
      const first_modulo = this.getprimermodulo()
      if(!first_modulo){
        this.msg = 'Error: no hay modulo 0'
        return
      } 
      if(!first_modulo.inicio) {
        this.msg = 'Error: el primer modulo no tiene fecha de inicio, no se puede continuar.'
        return
      }

    },
    validardatosrest() {
      this.msg = ''; 
      const vue = this;
      let userid = this.$store.state.DATA_USER.id;
      var obj = window.Object.assign({}, this.inscripcionrest);
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      
      
      if(unidad == -1){ // solo esam 
        const vs1 = this.verificar_cuotas_personal_esam()
        if( !vs1.valido ){
          this.msg = vs1.msg
          return;
        }
        this.validar_modulocero()
        if(this.msg){
          return
        }
      }

      const errores = validarFechasPagos(this.planseleccionado.cobros) 
      if(errores.length > 0){ 
        const p = errores[0]
        const t = `En ${p.nombre} entre la cuota ${p.cuotaAnterior} y ${p.cuotaSiguiente} no puede haber mas de 31 dias de diferencia [${p.diferenciaDias}]`;
        this.msg = t
        return;
      }

      if (!this.inscripcion.idestudiante) {
        this.msg = 'Seleccione un estudiante';
        return;
      } 

      if (!this.inscripcion.idusuario) this.inscripcion.idusuario = { id: userid };
      if (!this.inscripcion.idusuario) {
        this.msg = 'Seleccione un asesor';
        return;
      }
      if (!this.programa.id) {
        this.msg = 'No hay programa seleccionado, salga y vuelva a realizar la inscripcion.';
        return;
      }
      if (obj.observaciones && obj.observaciones.length < 5) {
        this.msg = 'La observacion es demasiado corta, ingrese al menos 5 caracteres.';
        return;
      }
      if (!obj.observaciones) delete obj.observaciones;

      obj.programa_id = this.programa.id;
      obj.estudiante_id = this.inscripcion.idestudiante.id;
      obj.asesor_id = this.inscripcion.idusuario.id;
      obj.registrado_por = userid;

      obj.plan_pagos = [];
      var cuotasvalidas = true;
      let msg_cuotas_val = '';
      if (!vue.preinscripcion && !vue.planseleccionado.plan_cobro_programa_id) {
        vue.msg = 'Seleccione un plan de pagos antes de continuar.';
        return;
      } else if (vue.planseleccionado.plan_cobro_programa_id) {
        obj.plan_cobro_programa_id = vue.planseleccionado.plan_cobro_programa_id;

        // 17 = C.A.S
        let idsede = this.$store.state.CARGO.idsede;

        this.planseleccionado.cobros.forEach(function (e) {
          let xmonto = 0;
          window.console.log('LOG:::::::::::', e.pagos.length, e);
          if (e.pagos.length > e.xmaxcuotas) {
            msg_cuotas_val = `El numero de cuotas a asignar(${e.pagos.length}) excede el maximo permitido(${e.xmaxcuotas}) definidoo en el programa para el concepto: ${e.nombre}, reduzca la cantidad de cuotas.`;
          }
          e.pagos.forEach(function (p) { 
            xmonto += p.monto;
            obj.plan_pagos.push({
              cobro_programa_id: p.cobro_programa_id,
              monto: p.monto,
              nro_cuota: p.nro_cuota,
              fecha_pago: p.fecha_pago,
            });
          });
          let po = vue.cobros_programa.find((x) => x.cobro_programa_id == e.cobro_programa_id);
          let pagooriginal = window.Object.assign({}, po); 
          if (idsede == 17) {
            xmonto = xmonto.toFixed(2);
            pagooriginal.monto = Number(pagooriginal.monto).toFixed(2); 
          }
 
          window.console.log('xpromo:::::::', vue.xpromo);
          if (!vue.xpromo) {
            let diferencia = pagooriginal.monto - xmonto;
            let tolerancia = 0.04;
            if (diferencia > tolerancia) {
              cuotasvalidas = false;
              vue.msg = `Las cuotas de ${e.nombre} (${xmonto}bs), no debe ser diferente a los ${pagooriginal.monto}Bs definido en el programa.`;
            }
          }
        });
        if (!cuotasvalidas) return;
      }

      if (msg_cuotas_val) {
        vue.msg = msg_cuotas_val;
        return;
      }
      
      let docus = [];
      if (vue.$refs.refDocs) {
        let opcionales = true;
        docus = vue.$refs.refDocs.getRequisitos(opcionales);
        if (typeof (docus) == 'string') {
          vue.msg = docus;
          return;
        }
        window.console.log('documentos:::', docus);
      }

      this.dialogoconfirm(obj, docus);
    },
    async getprogramarest(idprograma) {
      let unidadid = this.$store.state.CARGO.sede.unidad_negocio;
      this.loading = true;
      const vue = this;
      let myHeaders = getheadersrest();

      let urlacademico = `${this.api_rest}/esam/programa/id/${idprograma}`;
      var requestOptions = { method: 'GET', headers: myHeaders, url: urlacademico };
      let res = await xaxios.request(requestOptions);
      let result = res ? res.data : null;
       
      let sql = gql`query{ getSede(id:${result.sede_id}){id,nombre,unidad_negocio} }`
      const ressede= await this.$apollo.query({ query: sql }).then(({data})=>data).catch(e=>e);
      if(ressede && ressede.getSede){
        this.unidad_nego = ressede.getSede.unidad_negocio
      }else if(this.programa.sede){
        this.unidad_nego = this.programa.sede.unidad_negocio
      }

      if (!result) {
        vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO OBTENER DATOS DEL PROGRAMA.';
      } else if (result.error) {
        vue.msg = result.error;
      } else {
        if (result.universidad_id) vue.programa.universidad_id = result.universidad_id;

        if (vue.$refs.refDocs) {
          const institucionId = result.universidad_id;
          const categoriaId = this.programa.postgrado.categoria.id;
          vue.$refs.refDocs.cargarRequisitosDocs(institucionId, categoriaId);
        }

        vue.btntexto = 'Actualizar datos del programa';
        vue.titletexto = 'Actualizar datos del programa';
        vue.inscripcionrest.plan_pagos = [];
        if (result.planes) {
          var indicep = 0;

          result.planes.forEach(function (p) {
            //window.console.log(">>>", p,urlacademico);
            p.cobros = p.cobros.filter(function (cobro) {
              return !cobro.opcional;
            }); // eliminamos los opcionales
            if (unidadid == 1) p.cobros = vue.ordenarEsamCCA(p.cobros);
            if (unidadid == 10) p.cobros = vue.ordenarDBS(p.cobros);
            if (unidadid == 15) p.cobros = vue.ordenarDBS(p.cobros);
            // window.console.log('p.cobros',p.cobros,unidadid);

            if (p.estado) vue.generarplan(p, indicep);
          });
        }

        if (vue.planes.length == 0) {
          vue.msg =
            'Este programa no tiene asignado ningun plan de pagos, debe ir a editar el programa y asignar los planes.';
        }
        // Las promociones se cargan al seleccionar el plan de pagos
      }
      vue.loading = false;
    },
    ordenarDBS(plandepagos = []) {
      const order = [1, 172, 133, 2, 3, 4];// ids conceptos
      let pls = plandepagos.sort((a, b) => {
        const indexA = order.indexOf(a.concepto_id);
        const indexB = order.indexOf(b.concepto_id);
        return indexA - indexB;
      });
      return pls;
    },
    ordenarEsamCCA(plandepagos = []) { 
      const order = [1, 2, 8, 3, 4];// ids conceptos
      let pls = plandepagos.sort((a, b) => {
        const indexA = order.indexOf(a.concepto_id);
        const indexB = order.indexOf(b.concepto_id);
        return indexA - indexB;
      });
      return pls;
    },
    generarplan(plan, indicep) {
      const vue = this;
      let date = new Date();
      let xidglobal = 0;

      // 17 = C.A.S
      let idsede = this.$store.state.CARGO.idsede;
      let totalplan = 0;
      let diferencia = 0;

      //window.console.log('>>>>',idsede);

      plan.cobros.forEach(function (e, indicex) {
        let cp = window.Object.assign({}, e);
        cp.znombre = plan.nombre + '_' + e.nombre;
        cp.planid = plan.plan_cobro_programa_id;
        vue.cobros_programa.push(cp);

        if (e.estado) {
          let submonto;
          if (idsede == 17) {
            //submonto = (e.monto / e.cuotas);
            submonto = Math.round((e.monto / e.cuotas) * 100) / 100;
          } else {
            submonto = parseInt(e.monto / e.cuotas);
          }
          let pad = e.monto - submonto * e.cuotas;
          let indice = 1;
          const pm2 = [];

          for (let i = 0; i < e.cuotas; i++) {
            let xmonto = submonto;
            if (i == 0 && idsede != 17) xmonto += pad;
            //window.console.log('PAD::::',pad,submonto,xmonto);

            if (i > 0) date.setDate(vue.dia_plazo);
            let d = date.getDate();
            let m = date.getMonth() + 1;
            let a = date.getFullYear();
            if (d < 10) d = '0' + d;
            if (m < 10) m = '0' + m;
            let fecha = a + '-' + m + '-' + d;
            date.setMonth(date.getMonth() + 1);

            pm2.push({
              cobro_programa_id: e.cobro_programa_id,
              monto: xmonto,
              nro_cuota: indice,
              estado: e.estado,
              xnombre: e.nombre,
              fecha_pago: null,
              xfecha_pago: fecha,
              saldo: xmonto,
              xid: indicex + indicep,
              xidglobal: xidglobal++,
            });
            totalplan += xmonto;
            indice++;
            indicep++;
          }
          e.pagos = pm2;

          if (idsede == 17) {
            totalplan = Math.round(totalplan * 100) / 100;
            diferencia = Math.round((e.monto - totalplan) * 100) / 100;
            e.pagos[e.pagos.length - 1].monto += diferencia;

            window.console.log('>>>diferencia', diferencia);
          }
        } else {
          vue.cuotasfalse += 1;
        }
      });
      //window.console.log('totalplan:::',totalplan);
      vue.planes.push(plan);
      //window.console.log("plan>", plan);
    },
    generarnumeroscuotas(e) {
      const vue = this;
      let idsede = this.$store.state.CARGO.idsede;
      let submonto;
      if (idsede == 17) {
        //submonto = (e.monto / e.cuotas);
        submonto = Math.round((e.monto / e.cuotas) * 100) / 100;
      } else {
        submonto = parseInt(e.monto / e.cuotas);
      }
      let pad = e.monto - submonto * e.cuotas;
      let indice = 1;
      let totalplan = 0;
      let diferencia = 0;
      this.loading = true;
      // 17 = C.A.S
      //const pm2 = [];
      setTimeout(function () {
        //setimeout sino la fecha no carga :(
        e.pagos = [];
        for (let i = 0; i < e.cuotas; i++) {
          let xmonto = submonto;
          if (i == 0 && idsede != 17) {
            xmonto += pad;
            //xmonto = Math.floor(xmonto);
            //xmonto = (parseInt(xmonto)*100) / 100;
          }
          let date = new Date();
          date.setMonth(date.getMonth() + i);
          if (i > 0) date.setDate(this.dia_plazo);
          let d = date.getDate();
          let m = date.getMonth() + 1;
          let a = date.getFullYear();
          if (d < 10) d = '0' + d;
          if (m < 10) m = '0' + m;
          let fecha = a + '-' + m + '-' + d;

          e.pagos.push({
            cobro_programa_id: e.cobro_programa_id,
            monto: xmonto,
            nro_cuota: indice,
            estado: e.estado,
            xnombre: e.nombre,
            fecha_pago: null,
            xfecha_pago: fecha,
            saldo: xmonto,
          });
          totalplan += xmonto;
          indice++;
          vue.loading = false;
        }
        totalplan = Math.round(totalplan * 100) / 100;
        diferencia = Math.round((e.monto - totalplan) * 100) / 100;
        //window.console.log('diferencia::::', diferencia);
        if (idsede == 1) {
          e.pagos[0].monto += diferencia;
          // e.pagos[0].monto = Math.ceil(e.pagos[0].monto);
        } else {
          e.pagos[e.pagos.length - 1].monto += diferencia;
        }
        //window.console.log('totalplan::::::',totalplan,diferencia);
      }, 300);

      //e.pagos = pm2;
    },

    dialogoconfirm(obj, docus) {
      const vue = this;
      vue.loading = true;

      this.$dialog
        .confirm(this.$store.state.alertmsg)
        .then(function () {
          if (vue.preinscripcion) vue.preinscribir(obj);
          else vue.inscribir(obj, docus);
        })
        .catch(function () {
          vue.loading = false;
        });
    },
    preinscribir(obj) {
      this.loading = true;
      const vue = this;
      delete obj.plan_pagos;
      delete obj.tipo_pago;

      window.console.log('pre-inscribir:::', JSON.stringify(obj, null, 4));

      /*var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");*/
      let myHeaders = getheadersrest();
      if (this.xpromo && this.xpromo.id) obj.promocion_id = this.xpromo.id;
      var raw = JSON.stringify(obj);
      var requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };
      window.console.log('>>>>>', raw, this.xpromo)

      let urlacademico = `${this.api_rest}/api/esam/preinscripcion`;
      fetch(urlacademico, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // window.console.log('PREINS:',result);
          if (!result) {
            vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO PREINSCRIBIR.';
          } else if (result.error) {
            vue.msg = result.error;
          } else {
            if (result.enrollment_id) {
              vue.msg = 'Pre inscrito correctamente, ID: ' + result.enrollment_id;
            } else {
              vue.msg = 'ERROR: ' + result;
            }
          }
          vue.loading = false;
        })
        .catch(() => {
          // window.console.log('error', error);
          vue.loading = false;
        });
    },
    async inscribir(obj, docus) {
      this.loading = true;
      const vue = this;

      let myHeaders = getheadersrest();
      if (this.xpromo && this.xpromo.id) obj.promocion_id = this.xpromo.id;
      if (this.comprobanteData){
        obj.monto= this.comprobanteData.monto;
        obj.fecha_pago= this.comprobanteData.fechaPago;
        obj.observaciones_pago= this.comprobanteData.comentario;
        obj.comprobante_pago= this.comprobanteData.archivoComprobante;

      }
      window.console.log('inscribir:::', JSON.stringify(obj, null, 4));
      var raw = JSON.stringify(obj);

      let urlacademico = `${this.api_rest}/api/esam/inscripcion`;
      var requestOptions = { method: 'POST', headers: myHeaders, body: raw, url: urlacademico };
      /* let res = await xaxios.request(requestOptions);
      let result = res? res.data : null; */

      fetch(urlacademico, requestOptions)
        .then((response) => response.json())
        .then(async (result) => {
          // window.console.log('GET PROGRMA:',result);
          if (!result) {
            vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO INSCRIBIR.';
          } else if (result.error) {
            vue.msg = result.error;
          } else {
            if (result.enrollment_id) {
              if (docus.length > 0) {
                await cargarDocs(docus, result.enrollment_id);
              }
              vue.msg = 'Inscrito correctamente, ID: ' + result.enrollment_id;
            } else {
              vue.msg = 'ERROR: ' + result;
            }
          }
          vue.loading = false;
        })
        .catch((e) => {
          // window.console.log('error', error);
          vue.msg = e;
          vue.loading = false;
        });
    },
    cambiocuotas(cuota) {
      // window.console.log( '>>>',cuota );
      cuota.pagos = [];
      this.generarnumeroscuotas(cuota);
    },
    validarcambioinscrito(flag) {
      this.msg = '';

      const errores = validarFechasPagos(this.planseleccionado.cobros)
      // window.console.log('errores validacion fechas:', errores);
      if(errores.length > 0){
        const p = errores[0]
        const t = `En ${p.nombre} entre la cuota ${p.cuotaAnterior} y ${p.cuotaSiguiente} no puede haber mas de 31 dias de diferencia.`;
        this.msg = t
        return;
      }
      
      const vue = this;
      let userid = this.$store.state.DATA_USER.id;
      var obj = window.Object.assign({}, this.inscripcionrest);
      if (obj.observaciones && obj.observaciones.length < 5) {
        this.msg = 'La observacion es demasiado corta, ingrese al menos 5 caracteres.';
        return;
      }
      if (!obj.observaciones) delete obj.observaciones;

      obj.plan_pagos = [];
      var cuotasvalidas = true;
      let msg_cuotas_val = '';
      if (!vue.planseleccionado.plan_cobro_programa_id) {
        if (vue.isgenerarplan)
          vue.msg = 'Seleccione un plan de pagos antes de generar el plan de pagos del estudiante.';
        else vue.msg = 'Seleccione un plan de pagos antes de realizar el cambio a inscrito.';
        return;
      } else if (vue.planseleccionado.plan_cobro_programa_id) {
        obj.plan_cobro_programa_id = vue.planseleccionado.plan_cobro_programa_id;

        // 17 = C.A.S
        let idsede = this.$store.state.CARGO.idsede;

        this.planseleccionado.cobros.forEach(function (e) {

          if (e.pagos.length > e.xmaxcuotas) {
            msg_cuotas_val = `El numero de cuotas a asignar(${e.pagos.length}) excede el maximo permitido(${e.xmaxcuotas}) definidoo en el programa para el concepto: ${e.nombre}, reduzca la cantidad de cuotas.`;
          }

          let xmonto = 0;
          // let fechas_validas = true;
          e.pagos.forEach(function (p) {
            xmonto += p.monto;
            obj.plan_pagos.push({
              cobro_programa_id: p.cobro_programa_id,
              monto: p.monto,
              nro_cuota: p.nro_cuota,
              fecha_pago: p.fecha_pago,
            });
            if (p.fecha_pago) {
              let ps = p.fecha_pago.split('/');
              let f = `${ps[2]}-${ps[1]}-${ps[0]}T23:59:00-04:00`;
              let dt = new Date(f);
              let hoy = new Date();
              if (dt < hoy) {
                cuotasvalidas = false;
                vue.msg = `la fecha no puede ser anterior a hoy en la cuota: ${p.nro_cuota}, ${p.fecha_pago}`;
              }
            } else {
              cuotasvalidas = false;
              vue.msg = 'las fechas en el plan de pagos no pueden estar vacias'
            }
            // window.console.log('fechaaaa:::', p.fecha_pago);
          });
          
          let pagooriginal = vue.cobros_programa.find((x) => x.cobro_programa_id == e.cobro_programa_id);

          if (idsede == 17) {
            xmonto = xmonto.toFixed(2);
            pagooriginal.monto = pagooriginal.monto.toFixed(2);
            //window.console.log( 'JEJEJEJEEJ:',xmonto);
          }
          if (!vue.xpromo) {
            let diferencia = pagooriginal.monto - xmonto;
            let tolerancia = 0.04;
            if (diferencia > tolerancia) {
              cuotasvalidas = false;
              vue.msg = `Las cuotas de ${e.nombre} (${xmonto}bs), no debe ser diferente a los ${pagooriginal.monto}Bs definido en el programa.`;
            }
          }
        });
        if (!cuotasvalidas) return;
      }

      if (msg_cuotas_val) {
        vue.msg = msg_cuotas_val;
        return;
      }
      
      window.console.log("this.store_inscripcion", this.store_inscripcion);
      let idins = 0;
      let idest = 0;
      if (this.programa.estudiante_id) idest = this.programa.estudiante_id;
      else idest = this.ispreinscrito.estudiante.id;

      if (this.store_inscripcion) idins = this.ispreinscrito.id;
      else idins = this.ispreinscrito.id;

      let body = {
        //inscripcion_id: this.store_inscripcion.id, // aqui taba el error
        inscripcion_id: idins,
        programa_id: this.programa.id,
        estudiante_id: idest,
        asesor_id: this.ispreinscrito.asesor.id,
        registrado_por: userid,
        tipo_pago: true, // true  a cuotas, false al contado
        plan_cobro_programa_id: this.planseleccionado.plan_cobro_programa_id,
        plan_pagos: obj.plan_pagos,
      };
      if (obj.observaciones) body.observaciones = obj.observaciones;

      window.console.log(window.stringifyObject(body), flag);
      this.xactualizarpersona(this.programa.estudiante_id);

      vue.loading = true;
      this.$dialog
        .confirm(this.$store.state.alertmsg)
        .then(function () {
          if (flag == 0) vue.generarplanplagos(body);
          else vue.cambioinscrito(body);
        })
        .catch(function () {
          vue.loading = false;
        });
    },
    cambioinscrito(obj) {
      this.loading = true;
      const vue = this; 
      let myHeaders = getheadersrest();
      if (this.xpromo && this.xpromo.id) obj.promocion_id = this.xpromo.id;
      var raw = JSON.stringify(obj, null, 4);
      var requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

      window.console.log(raw, obj);

      let urlacademico = `${this.api_rest}/api/esam/preinscripcion`;
      window.console.log(urlacademico);
      fetch(urlacademico, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // window.console.log('CAMBIOINS:',result);
          if (!result) {
            vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO PREINSCRIBIR.';
          } else if (result.error) {
            vue.msg = result.error;
          } else {
            if (result.enrollment_id) {
              vue.msg = 'Cambio realizado correctamente, ID: ' + result.enrollment_id;
              sessionStorage.removeItem('xpreinscrito');
              vue.$router.back();
            } else if (result.result) {
              vue.msg = 'Cambio realizado correctamente.';
              sessionStorage.removeItem('xpreinscrito');
              vue.$router.back();
            } else {
              vue.msg = 'ERROR: ' + result;
            }
          }
          vue.loading = false;
        })
        .catch(() => {
          // window.console.log('error', error);
          vue.loading = false;
        });
    },
    generarplanplagos(obj) {
      this.loading = true;
      const vue = this;
      //delete obj.plan_pagos;
      //delete obj.tipo_pago;

      /*var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");*/
      let myHeaders = getheadersrest();
      var raw = JSON.stringify(obj, null, 4);
      var requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };
      let urlacademico = `${this.api_rest}/api/esam/inscripcion/generate/plan`;
      window.console.log(urlacademico);

      if (this.remote_plan.length) {
        const url = `${this.api_rest}/api/esam/inscripcion/plan/eliminar`;
        xaxios
          .post(url, { inscripcion_id: this.programa.inscripcion_id })
          .then(() => {
            fetch(urlacademico, requestOptions)
              .then((response) => response.json())
              .then((result) => {
                // window.console.log('GENERAPLAN:',result);
                if (!result) {
                  vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO Generar el plan.';
                } else if (result.error) {
                  vue.msg = result.error;
                } else {
                  this.$root.$notify.show(`Nuevo Plan Asignado correctamente`, { color: 'success', x: 'left' });
                  if (result.enrollment_id) {
                    vue.msg = 'plan generado exitosamente, ID: ' + result.enrollment_id;
                    sessionStorage.removeItem('xpreinscrito');
                    sessionStorage.removeItem('xinscritotoplan');
                    vue.$router.back();
                  } else if (result.result) {
                    vue.msg = 'plan generado exitosamente.';
                    sessionStorage.removeItem('xpreinscrito');
                    sessionStorage.removeItem('xinscritotoplan');
                    vue.$router.back();
                  } else {
                    vue.msg = 'ERROR: ' + result;
                  }
                }
                vue.loading = false;
              });
          })
          .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
      } else {
        fetch(urlacademico, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // window.console.log('GENERAPLAN:',result);
            if (!result) {
              vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO Generar el plan.';
            } else if (result.error) {
              vue.msg = result.error;
            } else {
              this.$root.$notify.show(`Plan Generado correctamente`, { color: 'success', x: 'left' });
              if (result.enrollment_id) {
                vue.msg = 'plan generado exitosamente, ID: ' + result.enrollment_id;
                sessionStorage.removeItem('xpreinscrito');
                sessionStorage.removeItem('xinscritotoplan');
                vue.$router.back();
              } else if (result.result) {
                vue.msg = 'plan generado exitosamente.';
                sessionStorage.removeItem('xpreinscrito');
                sessionStorage.removeItem('xinscritotoplan');
                vue.$router.back();
              } else {
                vue.msg = 'ERROR: ' + result;
              }
            }
            vue.loading = false;
          })
          .catch(() => {
            // window.console.log('error', error);
            vue.loading = false;
          });
      }
    },

    // CANALES
      async getCanales(){
        this.loading_canales = true;
        let sql = gql`query{ getCanales{ id nombre } }`
        const res = await this.$apollo.query({ query: sql }).then(data=>data).catch(e=>e);
        if(res && res.data){
          // window.console.log('canales:::', res.data);
          this.canales = res.data.getCanales;
        }
        this.loading_canales = false;
      },

      verificar_is_upi(){
        // window.console.log('??this.programa::',this.programa);
        /* const e = (window.location.href+'')
        if((e.includes('localhost') || e.includes('webdev')) ){
          if(this.programa.sede && this.programa.sede.unidad_negocio == 15){
            this.$refs.refmodal_propuesta.openmodal(this.programa)
          }
        } */
      },

    formatCode(p) {
      if (this.programa && this.programa.postgrado) {
        return `${this.programa.postgrado.categoria.nombre.slice(0, 1)}-${this.programa.id}`.toUpperCase();
      }
      return p.codigo ? p.codigo : p.id;
    },
    marcarpagado(plan) {
      // window.console.log( plan );
      const opt = {
        okText: 'Continuar',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'classic',
      };
      const message2 = {
        title: 'Confirmacion.',
        body: 'Usted esta indicando que esta cuota ya fue pagada por el estudiante, debe indicar la fecha del pago realizado y definir las nuevas fechas de pago, caso contrario puede cancelar.',
      };
      this.$dialog
        .confirm(message2, opt)
        .then(function (dialog) {
          plan.saldo = 0;
          dialog.close();
        })
        .catch(function () { });
    },
    onnewregistro(data, creado) {
      // this.inscripcion.idestudiante = creado;
      // window.console.log('On New Reg: ', data,creado);
      this.$refs.abuscarestudiante.setNew(creado);
    },
    cleanedstring(str, sinespacios = false) {
      if (!str) return str;
      str = str.toLowerCase();
      str = str.replace(/ +/g, ' ');
      str = str.replace(/á/gi, 'a');
      str = str.replace(/é/gi, 'e');
      str = str.replace(/í/gi, 'i');
      str = str.replace(/ó/gi, 'o');
      str = str.replace(/ú/gi, 'u');
      str = str.replace(/ñ/gi, 'n');
      if (sinespacios) str = str.replace(/ +/g, '');
      return str;
    },
    generateaccess(input) {
      let iniciala = '';
      let inicialb = '';
      let user = '';
      let pass = '';
      input.nombres = this.cleanedstring(input.nombres);
      input.primer_apellido = this.cleanedstring(input.primer_apellido, true);
      input.segundo_apellido = this.cleanedstring(input.segundo_apellido, true);
      let nombres = input.nombres.split(' ');
      iniciala = nombres[0].substring(0, 1);
      if (nombres[1]) inicialb = nombres[1].substring(0, 1);
      pass = input.numero_documento;
      user += iniciala + inicialb + input.primer_apellido.toLowerCase();
      if (input.segundo_apellido) user += input.segundo_apellido.toLowerCase();
      if (input.departamento) pass += input.departamento.extension;
      //let time = new Date().getTime().toString();
      //user += '-' + time.substring(time.length - 5);
      return { username: user, password: pass };
    },
    /*
    Obtiene a la persona, verificar si tiene usuario y clave moodle
    Si no tiene se actualiza creando su usuario y clave
    Esto porque desde el formulario de preinscripcion no lo crea**/
    xactualizarpersona(idpersona) {
      const url = `${process.env.VUE_APP_API_REST}/esam/persona/id/${idpersona}`;
      xaxios.get(url).then(({ data }) => {
        window.console.log('getdata:::', data.persona, idpersona);
        if (data && !data.persona.usuario_moodle) {
          let acc = this.generateaccess(data.persona);
          let idciudad = 1;
          let idpais = 1;
          let iddepartamento = 1;
          let idprofesiones = [];
          if (data.persona.ciudad) idciudad = data.persona.ciudad.id;
          if (data.persona.pais) idpais = data.persona.pais.id;
          if (data.persona.departamento) iddepartamento = data.persona.departamento.id;
          if (data.persona.profesiones)
            idprofesiones = data.persona.profesiones.map((x) => {
              return x.id;
            });
          else idprofesiones = [3];
          if (!data.persona.sexo) data.persona.sexo = 'M';
          if (!data.persona.estado_civil) data.persona.estado_civil = 'S';
          let input = {
            num_doc: data.persona.numero_documento,
            nombres: data.persona.nombres,
            pri_apellido: data.persona.primer_apellido,
            email: data.persona.email,
            sexo: data.persona.sexo,
            tipo: data.persona.tipo,
            diestro: true,
            iddepartamento: iddepartamento,
            idpais: idpais,
            idciudad: idciudad,
            est_civil: data.persona.estado_civil,
            telefono1: data.persona.telefono1,
            seg_apellido: data.persona.segundo_apellido,
            usuario_moodle: acc.username,
            clave_moodle: acc.password,
            id: data.persona.id,
            profesiones: idprofesiones,
          };
          window.console.log('Actualizando persona....', input);

          const sql = gql`mutation{updatePersona(input:${window.stringifyObject(input)}){ ok,  errors{message}}}`;
          this.$apollo
            .mutate({ mutation: sql })
            .then((data) => {
              if (!data.data) data.data = {};
              let updatePersona = data.data.updatePersona;
              window.console.log(updatePersona);
              if (!updatePersona || !updatePersona.ok) {
                let txt = `NO SE PUDO ACTUALIZAR PERSONA: (Inscripcionrest-add.vue) \n\n ${JSON.stringify(input)}`;
                fetch(
                  'https://api.telegram.org/bot1780932396:AAER4sTDMHBpWkiS66wVZVN9TenE7wUZ9Mg/sendMessage?chat_id=293911327&text=' +
                  txt,
                )
                  .then((response) => response.json())
                  .then((data) => {
                    window.console.log(data);
                  });
              }
            })
            .catch((err) => {
              window.console.error(err);
            });
        }
      });
    },
    async getPromoV3(idprograma, plan_cobro_programa_id) {
      if (!plan_cobro_programa_id) return;
      this.loading_promo_v3 = true;
      this.xpromos_v3 = [];
      this.xpromo_v3 = null;
      try {
        const res = await xaxios.request({
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/v3/programa/${idprograma}/aprobado`,
          params: { plan_cobro_programa_id },
        });
        this.xpromos_v3 = res.data.data || res.data || [];
      } catch (e) {
        window.console.error('Error cargando promociones v3', e);
      } finally {
        this.loading_promo_v3 = false;
      }
    },
    aplicarPromocionV3() {
      if (!this.xpromo_v3) return;
      const detalle = [];
      (this.xpromo_v3.reglas || []).forEach(regla => {
        (regla.conceptos || []).forEach(c => {
          detalle.push({
            concepto_pago_id: c.concepto_pago_id,
            valor_descuento: c.valor_descuento,
            is_porcentaje: c.is_porcentaje,
            nombre_concepto: `Concepto #${c.concepto_pago_id}`,
          });
        });
      });
      this.xpromo = { ...this.xpromo_v3, detalle_promocion: detalle };
      this.aplicarPromocion();
    },
    getPromo(idprograma) {
      const idprograma_omit = 3056;
      const idprograma_omit2 = 3059;
      const idprograma_omit3 = 3074;
      if (this.programa && (this.programa.id == idprograma_omit || this.programa.id == idprograma_omit2 || this.programa.id == idprograma_omit3)) {
        this.$root.$notify.show(`Este programa no esta permitido para aplicarse la promocion.`, {
          color: 'danger',
          x: 'left',
        });
        return;
      }
      this.loading_promo = true;
      let vue = this;
      var config = {
        method: 'get',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/programa/${idprograma}/aprobado`,
        headers: {},
      };

      xaxios.request(config)
        .then(function (response) {
          let data = response.data.data;
          window.console.log('promo >>>> ', data, idprograma);
          /*if(idprograma == 3118 ){
            data = data.filter(p=>p.id == 506 || p.id == 540);
            window.console.log('filtrado: ', data)
          }*/
          vue.xpromos = data;
          vue.loading_promo = false;
        })
        .catch(function (error) {
          window.console.log(error);
          vue.loading_promo = false;
        });
    }, 
  },
  mounted() {
    let unidad = this.$store.state.CARGO.sede.unidad_negocio
    if(unidad != 1 && unidad != 5) {
      this.$router.push('/inscripcionrestx');
      return;
    }

    let apidev = process.env.VUE_APP_GRAPHQL;
    if( apidev.includes("apidev") ){ this.isdevmode = true; }
    else{ this.isdevmode = false; }

    // this.unidad_nego = this.$store.state.sede.unidad_negocio;

    let cambiopreinscrito = sessionStorage.getItem('xpreinscrito');
    let generarplaninscrito = sessionStorage.getItem('xinscritotoplan');
    let xpro = sessionStorage.getItem('xprograma');

    this.getCanales();
    if (cambiopreinscrito) {
      this.isgenerarplan = cambiopreinscrito.estado_ins == 1;
      this.ispreinscribir = true;
      this.ispreinscrito = JSON.parse(cambiopreinscrito);
    } else if (!cambiopreinscrito && generarplaninscrito) {
      this.isgenerarplan = true;
    }
    if (generarplaninscrito) {
      this.ispreinscrito = JSON.parse(generarplaninscrito);
    }
    window.console.log('<>XREST<>: ', this.ispreinscrito);

    if (xpro) {
      // tambien se usa en AexcelInscribirProgramas.vue
      var ob1 = JSON.parse(xpro);
      if (!isNullObject(ob1)) {
        this.remote_plan = ob1 && ob1.plan_pagos ? ob1.plan_pagos : [];
        // window.console.log('mounted line 573:  ',this.remote_plan);
        this.programa = ob1;
        this.verificar_is_upi()
        //quitar esto, es solo test
        //window.console.log('prooooo', this.programa);
        if (this.programa.estudiante_id) this.xactualizarpersona(this.programa.estudiante_id);
      }
    }
    if (cambiopreinscrito) {
      var ob = JSON.parse(cambiopreinscrito);
      if (!isNullObject(ob)) this.inscripcion = ob;
    }
    if (isNullObject(ob1)) {
      this.$notify(error('Error', 'No existe el programa seleccionado, vuelva atras y seleccione uno.'));
    }
    if (this.programa) {
      this.inscripcionrest.programa_id = this.programa.id;
      this.getprogramarest(this.programa.id);
    }
    var ats = window.sessionStorage.route_ins;
    if (ats) this.atras = ats;
 
  },
};
</script> 
